export default __webpack_public_path__ + "images/cena_active.png";